<template>
<div>
<groups_wrapper   :groups='groups' :beforeDisplayedQ="beforeDisplayedQ"  @offSetChange="offSetChange()"   > </groups_wrapper>
<v-dialog v-model="groups.modals.msg"  width="950" scrollable persistent>
<msg v-if="groups.modals.msg" :groups='groups'> </msg>
</v-dialog>
</div>
</template>




<script>
import axios from 'axios'
import groups_wrapper from './groups_wrapper.vue'
import msg from './msg.vue'
export default {
components:{msg,groups_wrapper},
 data: function(){
  return {


groups:{
update_params:{is:false},
sort:{
selected:"by_none",
options:[
{
text:"По умолчанию",
value:"by_none"
},
{
text:"Активность выше",
value:"by_activiti_more"
},
{
text:"Активность ниже",
value:"by_activiti_less"
},
{
text:"По колличеству ботов",
value:"by_bots"
},
{
text:"По проценту ботов",
value:"by_bot_percent"
},
{
text:"По скрытым подпискам",
value:"by_hidden_members"
},
{
text:"По колличеству подписок",
value:"by_followers_count"
},
{
text:"Выключенное автообновление",
value:"by_mute"
},
],
},
renameList: {
    title: '',
    loading: false,
},
removeList: {
    loading: false,
},
selectedCat: 'Общий список',
catList: [],



loading: true,
lastQ: "",
q:"",
msgItem:{},  //  передать инфо о группе, где хотим посмотреть сообщения
paramsItem:{},  //  передать инфо о группе, где хотим изменить уникальные параметры
all:[],
active:[],
displayCount:25,
beforeDisplayed:[],
selected:[],
selector: false,
checkList: [],

searcher: {
list:[],
count:0,
offset:0
},

deleteId: [],
deleteParams:{
deleteSavedFollowers:false,
toBlackList:{
is:false,
reasonText:"",
}
},


modals :{
update_params:false,
msg:false,
gr_params:false,
watch_new_followers:false,
addGroups:false,
deleteGroup: false,
deleteSelected: false,
checkGroup: false,
history: false,
changeCatSelected: false,
renameCatSelected: false,
removeCatSelected: false,
},

  history: {
    inMode:true,
    outMode:false,
    historyId: '',
    foundData:{
     selector: false,
     foundIds: [],
     displayIds: [],
     selectedIds: [],
     offset: 0,
     selectAll: false
   },

   foundDataOut:{
    selector: false,
    foundIds: [],
    displayIds: [],
    selectedIds: [],
    offset: 0,
    selectAll: false
  },


    menegerIn: {
        marginTop: '0px',
        snackbarAbsoute: true,
        items: {
          selector: {active:true},
          copy: {active:true},
          export: {active:true},
          update: {active:false},
          delete: {active:false},
          autoExport: {active:false}
        },
        contentInfo: {
          type: 'pages',
        },
        autoExport: {
          isActive: false,
          tasksList:[],
       },


     },
     menegerOut: {
         marginTop: '0px',
         snackbarAbsoute: true,
         items: {
           selector: {active:true},
           copy: {active:true},
           export: {active:true},
           update: {active:false},
           delete: {active:false},
           autoExport: {active:false}
         },
         contentInfo: {
           type: 'pages',
         },
         autoExport: {
           isActive: false,
           tasksList:[],
        },


        }
  },
  checker: {
    foundData:{
     selector: false,
     foundIds: [],
     displayIds: [],
     selectedIds: [],
     offset: 0,

   },
   foundDataOut:{
    selector: false,
    foundIds: [],
    displayIds: [],
    selectedIds: [],
    offset: 0,

  },
    pages: {
      q: "",
      offset: 0 ,
      displayed: [],
      all_in: [],
      all_out: [],
    },
    updater: {
      id : "",
      status : true
    },

  },
},
updater: {
  id : "",
  status : true
}

  }
},
created(){
window.addEventListener('scroll', this.handleScroll)

  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
     method: 'POST',
     data : {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected },
     }).then(response => {
 this.groups.loading = false
 if(response.data.one.groups){
 this.groups.all = response.data.one.groups
 this.groups.catList = response.data.one.catList
 this.groups.selectedCat = response.data.one.selectedCat
} else this.groups.all = []
 this.active
 this.groups.beforeDisplayed = this.groups.active
     })

},
mounted( ){
this.updater.id = setInterval( ()=>{

if(this.groups.selected.length<1){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
method: 'POST',
data: {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected}
}).then(response => {
this.groups.catList = response.data.one.catList
this.groups.selectedCat = response.data.one.selectedCat
this.groups.loading = false
if(response.data.one.groups){
this.updateGroups(response.data.one.groups)
}
})
}
}, 8000)
},
destroyed(){
window.removeEventListener('scroll', this.handleScroll)
clearInterval(this.updater.id)
},

computed:{
   active: function(){

     if(this.groups.all.length>0) {
    this.groups.active = this.groups.all.filter(function(item, i, arr){
      return item.activiti !== 0
    })
  } else this.groups.active = []

  },

  beforeDisplayedQ (){
if(this.groups.q == '!active'){
  this.groups.searcher.list = []
  this.groups.searcher.offset = 0
  this.active
   this.groups.q = ""
  this.groups.beforeDisplayed = this.groups.active
    return   this.groups.beforeDisplayed
}


else if(this.groups.q == '!deleteSelected'){

  this.groups.searcher.list = []
  this.groups.searcher.offset = 0
   this.groups.q = this.groups.lastQ


this.groups.selected.forEach( (item,i,arr)=>{
  this.groups.all.splice(this.groups.all.indexOf(item),1)
  this.groups.beforeDisplayed.splice(this.groups.beforeDisplayed.indexOf(item),1)
})
let list = []
  this.groups.selected.forEach( (item,i,arr)=>{
    list.push(item.id_of_group)
  })
list = list.join(',')
  this.active
this.groups.selected= []
this.deleteGroup(list)
return this.groups.beforeDisplayed
}
else if(this.groups.q == '!update'){

 if(this.groups.all.length > 0) {

  this.groups.q = this.groups.lastQ

  this.active
  let theQ = this.groups.q

if(true){  //theQ == ""
  let filter = new RegExp( this.groups.q, 'ig')
      this.groups.beforeDisplayed = this.groups.all.filter(function(item, i, arr){
        return item.name.match(filter)
      })
}
return this.groups.beforeDisplayed
}
}
else{
  this.groups.beforeDisplayed.forEach(function(item, i, arr){
    item.add_info.selected = false
  })
    this.groups.selected = []
    this.groups.selector = false


    this.groups.searcher.list = []
    this.groups.searcher.offset = 0
let filter = new RegExp(this.groups.q, 'i')
    this.groups.beforeDisplayed = this.groups.all.filter(function(item, i, arr){
      return item.name.match(filter)
    })

    return   this.groups.beforeDisplayed


}
  }



},
methods:{


handleScroll (event) {
if(this.groups.displayCount <= this.beforeDisplayedQ.length){
this.groups.displayCount += 1
//console.log(event)
}
},

updateGroups(data){
if(this.groups.selected.length < 1){
this.groups.lastQ = this.groups.q
this.groups.all = data
if(this.groups.all.length > 0 ){
this.groups.q = "!update"
}
}
},


  offSetChange: function(){

    this.offset = this.offset + 10
    this.groups.displayed= this.groups.beforeDisplayed.slice(0,this.offset)
    this.nonDisplayed
  },


deleteGroup: function(list){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_delete.php', {
method: 'POST', data: {ids:list,params:this.groups.deleteParams}
}).then(response => {
this.$store.dispatch('changeCounters')
})
}
}
}
</script>

<style>
#groups_menegment_wrapper {

  float: left;
  width: 245px;
  height: 300px;

}
#groups_wrapper {

  float: left;
  width: 600px;
  min-height: 300px;

}
</style>
